type RoundedButtonProps = {
    className?: string;
    theme: string;
    label: string;
    onClick: () => void;
    disabled?: boolean;
};

export default function RoundedButton({ className, theme, label, onClick, disabled }: RoundedButtonProps) {
    const stateClasses = disabled ? 'md:mt-0 mt-6 disabled disabled:opacity-100' : '';

    return (
        <div
            className={`${stateClasses} active: shadow-blue hover:shadow-blueactive relative cursor-pointer rounded-full bg-gradient-to-b from-gradient-ar-${theme}-from to-gradient-ar-${theme}-to px-10 py-2.5 text-center text-md font-semibold text-white transition-all duration-200 ease-in-out hover:scale-101 active:scale-100 active:shadow-none ${className}`}
            onClick={onClick}
        >
            {label}
        </div>
    );
}
